class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    const productBlock = this.querySelector('.custom-sub-widget');
    const sellingPlanInput = document.createElement('input');
    sellingPlanInput.type = 'hidden';
    sellingPlanInput.name = 'selling_plan';
    productBlock.appendChild(sellingPlanInput);

    const purchaseOptions = productBlock.querySelectorAll('.purchase-option');
    const subscribeOptionsWrap = productBlock.querySelector('.subscribe-options-wrap');
    const selectElement = productBlock.querySelector('.select__select');
    const subscribeRadio = productBlock.querySelector('#product-subscribe');
    const onetimeRadio = productBlock.querySelector('#product-onetime');

    // Custom card elements
    const customCards = document.querySelectorAll('.zs-purchase-option-card');
    const deliveryButtons = document.querySelectorAll('.zs-purchase-option .delivery .options button');

    let sealSubscribeRadio = null;
    let sealOnetimeRadio = null;
    let sealWidgetReady = false;
    let currentSelectedOption = 'subscribe';
    let sealIntervalSelect = null;
    let sealWidgetElement = null;

    // Map button indices to selling plan IDs
    const intervalMapping = [
      '693930295666',  // 1 month
      '693934817650',  // 2 months
      '693934850418'   // 3 months
    ];

    // Use MutationObserver to watch for Seal Subscriptions widget
    function observeSealWidget() {
      const observer = new MutationObserver((mutations, obs) => {
        sealSubscribeRadio = document.querySelector('.sls-option[data-type="subscription"]');
        sealOnetimeRadio = document.querySelector('.sls-option[data-type="one_time"]');
        sealIntervalSelect = document.querySelector('.sls-select[name="subs_interval"]');
        sealWidgetElement = document.querySelector('.sealsubs-target-element');
        
        if (sealSubscribeRadio && sealOnetimeRadio && sealIntervalSelect) {
          sealWidgetReady = true;
          obs.disconnect();
          
          // Set up price syncing
          syncPrices();
          observePriceChanges();
          
          // Listen to Seal's selling plan change events
          listenToSealEvents();
          
          // Trigger initial state
          if (subscribeRadio.checked) {
            sealSubscribeRadio.click();
          } else if (onetimeRadio.checked) {
            sealOnetimeRadio.click();
          }

          // Sync initial interval selection
          syncIntervalButtons();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      setTimeout(() => observer.disconnect(), 10000);
    }

    // Listen to Seal Subscriptions events
    function listenToSealEvents() {
      // Listen for selling plan changes
      document.addEventListener('sealsubs:selling_plan_changed', function(e) {
        if (e.detail) {
          const { selling_plan_id } = e.detail;
          
          // Update our hidden input
          sellingPlanInput.value = selling_plan_id || '';
          
          // Sync prices after plan change
          setTimeout(syncPrices, 50);
          
          // Update active delivery button
          syncIntervalButtons();
        }
      });
    }

    // Sync active state of interval buttons with Seal widget
    function syncIntervalButtons() {
      if (!sealIntervalSelect) return;

      const selectedValue = sealIntervalSelect.value;
      const selectedIndex = intervalMapping.indexOf(selectedValue);

      deliveryButtons.forEach((btn, index) => {
        btn.classList.toggle('active', index === selectedIndex);
      });
    }

    // Sync prices from Seal widget to custom cards
    function syncPrices() {
      const subscribePrice = document.querySelector('.sls-selling-plan-group-price .money');
      const onetimePrice = document.querySelector('.sls-one-time-price .money');
      const customSubscribePrice = document.querySelector('.zs-purchase-option-card[data-purchaseOption="subscribe"] .right strong');
      const customOnetimePrice = document.querySelector('.zs-purchase-option-card[data-purchaseOption="onetime"] .card-header strong');

      if (subscribePrice && customSubscribePrice) {
        const priceText = subscribePrice.textContent.trim();
        customSubscribePrice.innerHTML = priceText;
      }

      if (onetimePrice && customOnetimePrice) {
        const priceText = onetimePrice.textContent.trim();
        customOnetimePrice.innerHTML = priceText;
      }

      // Update save amount
      if (subscribePrice && onetimePrice) {
        const subscribePriceValue = parseFloat(subscribePrice.textContent.replace(/[^0-9.]/g, ''));
        const onetimePriceValue = parseFloat(onetimePrice.textContent.replace(/[^0-9.]/g, ''));
        const saveAmount = onetimePriceValue - subscribePriceValue;
        const saveAmountElement = document.querySelector('.zs-purchase-option-card[data-purchaseOption="subscribe"] .right small');
        
        if (saveAmountElement && saveAmount > 0) {
          const currencyMatch = onetimePrice.textContent.match(/[^\d.,\s]+/);
          const currency = currencyMatch ? currencyMatch[0] : 'NZ$';
          saveAmountElement.textContent = `You save ${currency}${saveAmount.toFixed(2)}`;
        }
      }
    }

    // Observe price changes in Seal widget
    function observePriceChanges() {
      const priceObserver = new MutationObserver(() => {
        syncPrices();
      });

      const subscribePrice = document.querySelector('.sls-selling-plan-group-price');
      const onetimePrice = document.querySelector('.sls-one-time-price');

      if (subscribePrice) {
        priceObserver.observe(subscribePrice, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }

      if (onetimePrice) {
        priceObserver.observe(onetimePrice, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }

    function toggleButtonDisplay() {
      const buttonText = document.querySelector('.product-form__button--text');
      const buttonPrice = document.querySelector('.product-form__button--price');

      if (currentSelectedOption === 'subscribe') {
        if (buttonText) buttonText.classList.add('hidden');
        if (buttonPrice) buttonPrice.classList.remove('hidden');
      } else {
        if (buttonText) buttonText.classList.remove('hidden');
        if (buttonPrice) buttonPrice.classList.add('hidden');
      }
    }

    function updateSellingPlan(event) {
      sellingPlanInput.value = event.target.value;
    }

    function updateTab(selectedOption) {
      currentSelectedOption = selectedOption;

      purchaseOptions.forEach(option => {
        const isSelected = option.dataset.purchaseoption === selectedOption;
        option.classList.toggle('selected', isSelected);
      });

      // Update custom cards
      customCards.forEach(card => {
        const isSelected = card.dataset.purchaseoption === selectedOption;
        card.classList.toggle('selected', isSelected);
      });

      // Show/hide one-time purchase description
      const onetimeDescription = document.querySelector('.purchase-option-one-description');
      if (onetimeDescription) {
        onetimeDescription.style.display = selectedOption === 'onetime' ? 'block' : 'none';
      }

      const contents = productBlock.querySelectorAll('.tab-content');
      contents.forEach(content => {
        content.style.display = content.dataset.content === selectedOption ? 'block' : 'none';
      });

      if (selectedOption === 'subscribe') {
        subscribeOptionsWrap.style.display = 'block';
        const selectedValue = selectElement?.value;
        if (selectedValue) sellingPlanInput.value = selectedValue;
        subscribeRadio.checked = true;
        
        if (sealWidgetReady && sealSubscribeRadio && !sealSubscribeRadio.checked) {
          sealSubscribeRadio.click();
        }
      } else {
        // IMPORTANT FIX: Clear selling_plan for one-time purchase
        subscribeOptionsWrap.style.display = 'none';
        sellingPlanInput.value = '';
        sellingPlanInput.removeAttribute('value');
        onetimeRadio.checked = true;
        
        if (sealWidgetReady && sealOnetimeRadio && !sealOnetimeRadio.checked) {
          sealOnetimeRadio.click();
        }
      }

      toggleButtonDisplay();
      setTimeout(syncPrices, 50);
    }

    // Handle custom card clicks
    customCards.forEach(card => {
      card.addEventListener('click', () => {
        const selected = card.dataset.purchaseoption;
        updateTab(selected);
      });
    });

    // Handle delivery interval buttons using Seal's API
    deliveryButtons.forEach((button, index) => {
      button.addEventListener('click', (e) => {
        e.stopPropagation(); // Prevent card click
        
        // Update button styles immediately for visual feedback
        deliveryButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
        
        // Use Seal's custom event to change the selling plan
        if (sealWidgetReady && sealWidgetElement) {
          const sellingPlanId = intervalMapping[index];
          
          // Dispatch Seal's custom event to change selling plan
          const event = new CustomEvent("sealsubs:change_selected_selling_plan_id", {
            detail: {
              selling_plan_id: sellingPlanId
            }
          });
          sealWidgetElement.dispatchEvent(event);
          
          // Update our hidden input
          sellingPlanInput.value = sellingPlanId;
          
          // Sync prices after a short delay
          setTimeout(syncPrices, 100);
        }
        
        // Ensure subscribe option is selected when changing interval
        if (currentSelectedOption !== 'subscribe') {
          updateTab('subscribe');
        }
      });
    });

    purchaseOptions.forEach(option => {
      option.addEventListener('click', () => {
        const selected = option.dataset.purchaseoption;
        updateTab(selected);
      });
    });

    if (selectElement) {
      selectElement.addEventListener('change', updateSellingPlan);
    }

    // Listen for Shopify variant change
    const productForm = document.querySelector('product-form, form[action*="/cart/add"]');
    if (productForm) {
      productForm.addEventListener('change', (e) => {
        if (e.target.name === 'id') {
          setTimeout(() => {
            toggleButtonDisplay();
            syncPrices();
            syncIntervalButtons();
          }, 100);
        }
      });
    }

    // Set first delivery button as active by default
    if (deliveryButtons.length > 0) {
      deliveryButtons[0].classList.add('active');
    }

    updateTab('subscribe');
    observeSealWidget();
  }
}

customElements.define('subscription-widget', SubscriptionWidget);